// Real API calls
export const luxstansaBaseurl = `https://luxtansaresorts.com/services`;

export const booking = '/api/bookings';
export const contact = '/api/contact';
export const packageBooking = '/api/package-bookings';
